// src/services/notificationService.js
import { getToken, onMessage } from "firebase/messaging";
import { httpsCallable } from "firebase/functions";
import { messaging, functions } from "../firebase";
import { supabase } from "../supabase";

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      console.log('Notification permission granted.');
      // Get the token
      const token = await getToken(messaging, { vapidKey: 'BPiyPQp4N0ymk0u_g15b4vfkm4Wr_oKO9o03l5gimxnyqbOoO_Drt2HQUinw2IZAL8UlfzDQzcjhjBaTwIuqWvo' });
      console.log('FCM Token:', token);
      
      // Save this token to Supabase user_profiles table
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        const { error } = await supabase
          .from("user_profiles")
          .update({ fcm_token: token })
          .eq("id", session.user.id);

        if (error) {
          console.error("Error saving FCM token to Supabase:", error.message);
        } else {
          console.log("FCM token saved to Supabase successfully.");
        }
      } else {
        console.warn("No active user session found, token not saved to DB.");
      }

      return true;
    } else {
      console.log('Unable to get permission to notify.');
      return false;
    }
  } catch (error) {
    console.error('Error requesting notification permission', error);
    return false;
  }
};

export const setupForegroundMessages = (onMessageReceived) => {
  if (!messaging) return;
  onMessage(messaging, (payload) => {
    console.log('Message received in foreground: ', payload);
    if (onMessageReceived) {
      onMessageReceived(payload);
    }
  });
};

export const updateAppBadge = async (unreadCount) => {
  // Check if the Badging API is supported
  if ('setAppBadge' in navigator) {
    try {
      if (unreadCount > 0) {
        await navigator.setAppBadge(unreadCount);
      } else {
        await navigator.clearAppBadge();
      }
    } catch (error) {
      console.error('Error setting app badge:', error);
    }
  }
};

export const sendNotificationToUser = async (userId, title, body) => {
  try {
    const { data, error } = await supabase
      .from("user_profiles")
      .select("fcm_token")
      .eq("id", userId)
      .single();

    if (error) {
      console.error("Error fetching user token from Supabase:", error);
      return false;
    }

    if (data && data.fcm_token) {
      const sendPushNotification = httpsCallable(functions, 'sendPushNotification');
      const result = await sendPushNotification({
        fcmToken: data.fcm_token,
        title: title || "New Notification",
        body: body || "You have a new message!"
      });
      console.log("Notification sent successfully:", result.data);
      return true;
    } else {
      console.warn("User does not have an FCM token.");
      return false;
    }
  } catch (error) {
    console.error("Error sending notification:", error);
    return false;
  }
};
